import { Link } from "react-router-dom";
import { getBookCovers, getBookIdentity } from "./bookContent";
import { getLegalPages, legalOrder } from "../legal/legalContent";
import "./ProductInformation.css";
import { useLanguage } from "../shared/LanguageContext";
import { websiteCopy } from "../shared/websiteCopy";

function ProductInformation() {
  const { language } = useLanguage();
  const copy = websiteCopy[language].product;
  const legalPages = getLegalPages(language);
  const bookIdentity = getBookIdentity(language);
  const covers = getBookCovers(language);
  const paymentLink = language === "es"
    ? process.env.REACT_APP_STRIPE_PAYMENT_LINK_ES
    : process.env.REACT_APP_STRIPE_PAYMENT_LINK;

  return (
    <main className="product-info" data-testid="product-information">
      <header className="product-info__header">
        <p className="eyebrow">{copy.eyebrow}</p>
        <h1>{bookIdentity.title}</h1>
      </header>

      <section className="product-info__body">
        <figure className="product-info__cover" data-testid="product-cover-front">
          <img src={covers.front.src} alt={covers.front.alt} />
        </figure>

        <div className="product-info__details">
          <dl className="product-info__facts">
            <div className="fact" data-testid="fact-title">
              <dt>{copy.title}</dt>
              <dd>{bookIdentity.title}</dd>
            </div>
            <div className="fact" data-testid="fact-author">
              <dt>{copy.author}</dt>
              <dd>{bookIdentity.author}</dd>
            </div>
            <div className="fact" data-testid="fact-series">
              <dt>{copy.series}</dt>
              <dd>{bookIdentity.series}</dd>
            </div>
            <div className="fact" data-testid="fact-volumes">
              <dt>{copy.volumes}</dt>
              <dd>{bookIdentity.volumes}</dd>
            </div>
            <div className="fact" data-testid="fact-framing">
              <dt>{copy.framing}</dt>
              <dd>
                {bookIdentity.framing[0]}<br />
                {bookIdentity.framing[1]}
              </dd>
            </div>
            <div className="fact" data-testid="fact-format">
              <dt>{copy.format}</dt>
              <dd>{copy.completeFormat}</dd>
            </div>
            <div className="fact" data-testid="fact-price">
              <dt>{copy.price}</dt>
              <dd>{copy.oneTime}</dd>
            </div>
          </dl>

          <p className="product-info__offer" data-testid="product-offer">
            {copy.offer}
          </p>
        </div>
      </section>

      {/* COMMERCIAL CALL-TO-ACTION — Stripe Payment Link (Packet 006) */}
      <section id="purchase" className="product-info__cta" aria-labelledby="cta-heading" data-testid="commercial-cta">
        <h2 id="cta-heading">{copy.completeEdition}</h2>
        <p className="product-info__price" data-testid="product-price">
          <strong>$22.22 USD</strong> · {copy.oneTimePurchase}
        </p>
        <a
          href={paymentLink}
          target="_blank"
          rel="noopener noreferrer"
          className="product-info__cta-button product-info__cta-button--active"
          data-testid="purchase-cta"
        >
          {copy.purchaseEdition}
        </a>
        <p className="product-info__cta-note">
          {copy.paymentNote}
        </p>
      </section>

      {/* DIGITAL-PRODUCT DELIVERY BOUNDARY — reserved placeholders, not active */}
      <section className="product-info__delivery" aria-labelledby="delivery-heading" data-testid="delivery-boundary">
        <h2 id="delivery-heading">{copy.digitalDelivery}</h2>
        <p className="product-info__delivery-note">
          {copy.deliveryNote}
        </p>
        <ol className="delivery-stages" data-testid="delivery-stages">
          <li>{language === "es" ? "Autorización de compra" : "Purchase Authorization"} <span className="reserved-tag">{language === "es" ? "Reservado" : "Reserved"}</span></li>
          <li>{language === "es" ? "Confirmación de pago" : "Payment Confirmation"} <span className="reserved-tag">{language === "es" ? "Reservado" : "Reserved"}</span></li>
          <li>{language === "es" ? "Entrega digital autorizada" : "Authorized Digital Delivery"} <span className="reserved-tag">{language === "es" ? "Reservado" : "Reserved"}</span></li>
          <li>{language === "es" ? "Acceso del cliente" : "Customer Access"} <span className="reserved-tag">{language === "es" ? "Reservado" : "Reserved"}</span></li>
        </ol>
      </section>

      {/* LEGAL / INFORMATION STRUCTURE */}
      <section className="product-info__legal" aria-labelledby="legal-heading" data-testid="legal-structure">
        <h2 id="legal-heading">{copy.legalInformation}</h2>
        <ul className="legal-links" data-testid="legal-links">
          {legalOrder.map((slug) => (
            <li key={slug}>
              <Link to={`/legal/${slug}`} className="legal-link" data-testid={`legal-link-${slug}`}>
                {legalPages[slug].title}
              </Link>
            </li>
          ))}
        </ul>
      </section>

      <nav className="product-info__nav" data-testid="product-info-nav">
        <Link to="/mirror-of-the-mind/book" className="nav-link" data-testid="back-to-book">
          {copy.backToBook}
        </Link>
      </nav>
    </main>
  );
}

export default ProductInformation;
